/**
 * Sanitizes a string to be used as a valid tab value for Radix UI tabs.
 * Converts spaces and special characters to hyphens and ensures lowercase.
 *
 * @param value - The string to sanitize (e.g., "Executive Education")
 * @returns A sanitized string suitable for use as a tab value (e.g., "executive-education")
 *
 * @example
 * sanitizeTabValue("Executive Education") // "executive-education"
 * sanitizeTabValue("Master's Degrees") // "masters-degrees"
 * sanitizeTabValue("What others are saying") // "what-others-are-saying"
 */
export function sanitizeTabValue(value: string): string {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // Remove special characters except spaces and hyphens
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .replace(/-+/g, "-") // Replace multiple consecutive hyphens with single hyphen
    .replace(/^-|-$/g, ""); // Remove leading/trailing hyphens
}
